import { LazyMadeInAustralia } from "@faire/deprecated-retailer-visitor-shared/icons/MadeInCountry/LazyMadeInAustralia";
import { LazyMadeInCanada } from "@faire/deprecated-retailer-visitor-shared/icons/MadeInCountry/LazyMadeInCanada";
import { LazyMadeInEurope } from "@faire/deprecated-retailer-visitor-shared/icons/MadeInCountry/LazyMadeInEurope";
import { LazyMadeInEuropeanCountry } from "@faire/deprecated-retailer-visitor-shared/icons/MadeInCountry/LazyMadeInEuropeanCountry";
import { LazyMadeInUSA } from "@faire/deprecated-retailer-visitor-shared/icons/MadeInCountry/LazyMadeInUSA";
import React, { Suspense } from "react";

const MadeInCountrySuspense: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <Suspense fallback={null}>{children}</Suspense>;
};

export const MadeInUSA = ({ ...props }) => {
  return (
    <MadeInCountrySuspense>
      <LazyMadeInUSA {...props} />
    </MadeInCountrySuspense>
  );
};

export const MadeInCanada = ({ ...props }) => {
  return (
    <MadeInCountrySuspense>
      <LazyMadeInCanada {...props} />
    </MadeInCountrySuspense>
  );
};

export const MadeInEurope = ({ ...props }) => {
  return (
    <MadeInCountrySuspense>
      <LazyMadeInEurope {...props} />
    </MadeInCountrySuspense>
  );
};

export const MadeInEuropeanCountry = ({ ...props }) => {
  return (
    <MadeInCountrySuspense>
      <LazyMadeInEuropeanCountry {...props} />
    </MadeInCountrySuspense>
  );
};

export const MadeInAustralia = ({ ...props }) => {
  return (
    <MadeInCountrySuspense>
      <LazyMadeInAustralia {...props} />
    </MadeInCountrySuspense>
  );
};
